import { createContext } from 'react';
import { ZodError } from 'zod';

export type ToastSeverity = 'error' | 'warning' | 'info' | 'success';

export interface ToastQueueItem {
  id: string;
  message: string;
  severity: ToastSeverity;
}

export interface ToastQueueContextValue {
  toasts: ToastQueueItem[];
  pushToast: (_message: string, _severity?: ToastSeverity) => void;
  dismissToast: (_id: string) => void;
  clearAll: () => void;
  pushZodErrors: (error: ZodError) => void;
}

export const ToastQueueContext = createContext<ToastQueueContextValue | undefined>(undefined);
